<template>
  <b-modal
    id="payment-history-modal"
    ref="paymentHistoryModal"
    modal-class="settings-modal no-multiselect-overflow"
    :body-class="['body-wrapper', 'white-bg']"
    hide-header-close
    size="md"
    scrollable
    centered
    :hide-footer="true"
    @hidden="clear">
    <template slot="modal-header">
      <div class="flex center-all w-100">
        <h3 class="greedy">Payment history</h3>
        <SBIcon
          :icon="SBIconList.CLOSE_THIN"
          :color="SBColors.greyBorder"
          :hover-icon-color="SBColors.blackPrimary"
          pointer
          :size="10"
          @click="hide"/>
      </div>
    </template>
    <ScrollArea>
      <div
        v-for="(historyInvoice, index) in history"
        :key="index"
        class="flex center-all history-item"
        :class="[historyInvoice.status]" >
        <SBIcon
          v-if="historyInvoice.refunded"
          v-b-popover.hover="{ content: 'Refunded', animation: false, customClass: 'basic-popover', placement: 'top' }"
          class="mr-2"
          :icon="SBIconList.ARROW_ROUNDED"
          color="#0e8854"
          background-color="#DCF5E3"
          :hover-size="18"
          :border-radius="50"
          :size="10"/>
        <SBIcon
          v-else-if="historyInvoice.partiallyRefunded"
          v-b-popover.hover="{ content: `Partially refunded - ${Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(historyInvoice.refund_amount) }`, animation: false, customClass: 'basic-popover', placement: 'top' }"
          class="mr-2"
          :icon="SBIconList.ARROW_DOTS"
          color="#0e8854"
          background-color="#DCF5E3"
          :hover-size="18"
          :border-radius="50"
          :size="10"/>
        <SBIcon
          v-else-if="historyInvoice.status === 'open'"
          v-b-popover.hover="{ content: 'Open', animation: false, customClass: 'basic-popover', placement: 'top' }"
          class="mr-2"
          :icon="SBIconList.ARROW_ROUNDED"
          color="#697FFF"
          background-color="#e0e4ff"
          :hover-size="18"
          :border-radius="50"
          :rotate="135"
          :size="10"/>
        <SBIcon
          v-else-if="historyInvoice.status === 'paid'"
          v-b-popover.hover="{ content: 'Paid', animation: false, customClass: 'basic-popover', placement: 'top' }"
          class="mr-2"
          :icon="SBIconList.DONE_TICK"
          color="#54626c"
          background-color="#e6ebed"
          :hover-size="18"
          :border-radius="50"
          :size="8"/>
        <SBIcon
          v-else-if="historyInvoice.status === 'failed'"
          v-b-popover.hover="{ content: 'Overdue', animation: false, customClass: 'basic-popover', placement: 'top' }"
          class="mr-2"
          :icon="SBIconList.CLOSE_THICK"
          color="#ec5a61"
          background-color="#ffd8d9"
          :hover-size="18"
          :border-radius="50"
          :size="7"/>
        <p class="greedy">{{ (historyInvoice.created_at * 1000) | dateMMMDDYYYY }} - {{ Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(historyInvoice.total) }}</p>

        <a
          v-if="historyInvoice.status === 'open'"
          :href="historyInvoice.hosted_invoice_url"
          target="_blank" >
          <b-button class="pay-btn flex center-all" >
            <span>Pay</span>
          </b-button>
        </a>
        <a
          v-else
          :href="historyInvoice.hosted_invoice_url"
          target="_blank"
          class="view-invoice-btn" >View</a>
      </div>
    </ScrollArea>
  </b-modal>
</template>

<script>
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import ScrollArea from '../../../common/ScrollArea';

export default {
  name: 'PaymentHistoryModal',
  components: {
    SBIcon,
    ScrollArea,
  },
  data() {
    return {
      history: null,
      SBColors,
      SBIconList,
    };
  },
  methods: {
    clear() {
      this.history = null;
    },
    hide() {
      this.$refs.paymentHistoryModal.hide();
    },
    show(history) {
      this.history = history;
      this.$refs.paymentHistoryModal.show();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal .modal-dialog {
  .modal-header {
    h3 {
      font-size: 16px;
      font-weight: 500;
      color: $blackPrimary;
    }
  }
  .modal-content .modal-body {
    background-color: $white !important;
    padding: 0px !important;
    border-radius: 5px !important;
  }
}

.history-item {
  border-bottom: solid 1px #e0e7e9 !important;
  padding: 11px 20px 11px 18px !important;
  min-height: 50px;

  &:last-of-type {
    border-bottom: none !important;
  }

  &.open {
    color: #697fff !important;
  }

  p {
    margin-right: 10px;
  }
}

a {
  text-decoration: none;
}

.pay-btn {
  background-color: #fff !important;
  color: #141c20 !important;
  border: solid 1px #cfd8dc !important;
  padding: 4px 11px 4px !important;
  min-width: unset !important;

  span {
    font-size: 14px;
    font-weight: 500;
  }
}

.view-invoice-btn {
  color: $blackUltralight;
  padding-right: 7px;

  &:hover {
    color: $bluePrimary;
  }
}
</style>
